import React from "react"

const CopyrightPolicy = () => {
  return (
    <>
      <p>
        <strong>Notification of Copyright Infringement</strong>
      </p>
      <p>
        Teache, Inc. ("Teache") respects the intellectual property rights of
        others and expects its users to do the same.
      </p>
      <p>
        It is Teache&rsquo;s policy, in appropriate circumstances and at its
        discretion, to disable and/or terminate the account or access of users
        who repeatedly infringe or are repeatedly charged with infringing the
        copyrights or other intellectual property rights of others.
      </p>
      <p>
        In accordance with the Digital Millennium Copyright Act of 1998, the
        text of which may be found on the U.S. Copyright Office website at
        http://www.copyright.gov/legislation/dmca.pdf, Teache will respond
        expeditiously to claims of copyright infringement committed using the
        Teache website and mobile application (the "Site and Application") that
        are reported to Teache&rsquo;s Designated Copyright Agent, identified in
        the sample notice below.
      </p>
      <p>
        If you are a copyright owner, are authorized to act on behalf of a
        copyright owner, or are authorized to act under any exclusive right
        under copyright, please report alleged copyright infringements taking
        place on or through the Site and Application by completing the following
        DMCA Notice of Alleged Infringement and delivering it to Teache&rsquo;s
        Designated Copyright Agent. Upon receipt of the Notice, as described
        below, Teache will take whatever action, in its sole discretion, it
        deems appropriate, including removal of the challenged material from the
        Site and Application.
      </p>
      <p>
        <strong>DMCA Notice of Alleged Infringement ("Notice")</strong>
      </p>
      <ol>
        <li>
          Identify the copyrighted work that you claim has been infringed, or,
          if this Notice covers multiple copyrighted works, provide a
          comprehensive list of the copyrighted works that you claim have been
          infringed.
        </li>
        <li>
          Identify the material that you claim is infringing (or to be the
          subject of infringing activity) and that is to be removed or access to
          which is to be disabled and information reasonably sufficient to
          permit us to locate the material, including, at a minimum, if
          applicable, the URL of the link shown on the Site and Application
          where such material may be found.
        </li>
        <li>
          Provide your mailing address, telephone number, and, if available,
          email address.
        </li>
        <li>
          Include both of the following statements in the body of the Notice:
        </li>
        <ul>
          <li>
            "I hereby state that I have a good faith belief that the disputed
            use of the copyrighted material is not authorized by the copyright
            owner, its agent, or the law (e.g., as a fair use)."
          </li>
          <li>
            "I hereby state that the information in this Notice is accurate and,
            under penalty of perjury, that I am the owner, or authorized to act
            on behalf of the owner, of the copyright or of an exclusive right
            under the copyright that is allegedly infringed."
          </li>
        </ul>
        <li>
          Provide your full legal name and your electronic or physical
          signature.
        </li>
      </ol>
      <p>
        Deliver this Notice, with all items completed, to Teache&rsquo;s
        Designated Copyright Agent:
      </p>
      <p>
        Copyright Agent
        <br /> c/o Teache, Inc.
        <br /> 79 Madison Ave.
        <br /> New York, NY 10016
        <br /> hello@teache.co
      </p>
    </>
  )
}

export default CopyrightPolicy
